import register from 'preact-custom-element'

import { WrappedQuickSearch } from './components/QuickSearch'
import { WrappedSearchGrid } from './components/SearchGrid'
import { WrappedCollectionGrid } from './components/CollectionGrid'
import { CarouselRecommend } from './components/CarouselRecommend'
import { CarouselCollection } from './components/CarouselCollection'
import { CarouselTabbed } from './components/CarouselTabbed'
import { CarouselPwp } from './components/CarouselPWP'
import {
  CarouselRecommend as RecsCarouselRecommend,
  observedAttributes as recsObservedAttributes
} from './components/recommendations/Recommendations'

// Handle Registering Custom Elements

register(WrappedQuickSearch, 'x-athos-quick-search')
register(WrappedSearchGrid, 'x-athos-search-grid')
register(WrappedCollectionGrid, 'x-athos-collection-grid')

register(CarouselRecommend, 'x-athos-carousel-recommend', ['profile', 'item-class', 'product-id'])
register(CarouselTabbed, 'x-athos-carousel-tabbed', ['values', 'item-class', 'product-id', 'id-list'])
register(CarouselCollection, 'x-athos-carousel-collection', ['handle', 'item-class', 'control-class', 'toggle-controls', 'product-limit'])
register(CarouselPwp, 'x-athos-carousel-pwp', ['products', 'item-class'])

// Basecamp's recommendations-carousel block, on the Athos engine.
register(RecsCarouselRecommend, 'x-recs-recommend-carousel', recsObservedAttributes, { shadow: false })
